
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/funeral-recommend/list/[pageNum]",
      function () {
        return require("private-next-pages/funeral-recommend/list/[pageNum].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/funeral-recommend/list/[pageNum]"])
      });
    }
  